module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_0.1dac7b92.png";